import { useGet } from './useFetch'
import { useAuth } from './useAuth'
import { ApiResponse } from '@magnetar/admin-api-interfaces'
import { AdScheduleTemplate } from './useAdScheduleTemplates'

interface UseAdScheduleTemplateByIdParams {
  template_id: number | string | null
}

export interface AdScheduleTemplateWithApplications extends AdScheduleTemplate {
  applications?: Array<{
    application_id: number
    template_id: number
    clinic_id?: number
    broadcast_device_id?: number
    applied_by?: number
    applied_at: string
    is_active: boolean
    clinic?: {
      clinic_id: number
      clinic_name: string
      is_active: boolean
      tags?: string[]
    }
    broadcast_device?: {
      broadcast_device_id: number
      name?: string
      is_active: boolean
    }
  }>
}

export function useAdScheduleTemplateById({ template_id }: UseAdScheduleTemplateByIdParams) {
  const { token } = useAuth()

  const { data, error, mutate } = useGet<ApiResponse<AdScheduleTemplate>>(
    token && template_id ? `/api/ad-schedule-templates/${template_id}` : null,
    undefined,
    token ?? '',
  )

  return {
    template: data?.data || null,
    isLoading: !error && !data,
    isError: error,
    mutate,
  }
}

export function useAdScheduleTemplateApplications({
  template_id,
}: UseAdScheduleTemplateByIdParams) {
  const { token } = useAuth()

  const { data, error, mutate } = useGet<ApiResponse<AdScheduleTemplateWithApplications>>(
    token && template_id ? `/api/ad-schedule-templates/${template_id}/applications` : null,
    undefined,
    token ?? '',
  )

  return {
    template: data?.data || null,
    isLoading: !error && !data,
    isError: error,
    mutate,
  }
}
